import cx from 'classnames'

import { SanityImageFragment } from '@data/sanity/queries/types/image'

import LogoLink from './logo-link'

interface LogoProps {
  isInvertedLogo: boolean
  logo?: SanityImageFragment
  invertedLogo?: SanityImageFragment
}

const Logo = ({ isInvertedLogo, logo, invertedLogo }: LogoProps) => {
  const isInvertedLogoVisible = !!invertedLogo?.asset && isInvertedLogo

  return (
    <>
      {logo?.asset && (
        <LogoLink
          id="logo"
          image={logo}
          className={cx('transition-opacity', {
            'opacity-0': isInvertedLogoVisible,
          })}
        />
      )}

      {invertedLogo?.asset && (
        <LogoLink
          id="inverted-logo"
          image={invertedLogo}
          className={cx('transition-opacity', {
            'opacity-0': !isInvertedLogoVisible,
          })}
        />
      )}
    </>
  )
}

export default Logo
